import React from 'react';
import { DatePicker } from 'antd';
import moment, { Moment } from 'moment';
import './EqDatePicker.scss';

export interface IDatePickerOptions {
    label?: string | React.ReactNode;
    allowClear?: boolean;
    isSuffixIcon?: boolean;
    isBordered?: boolean;
    isDisabled?: boolean;
    defaultValue?: string | Date | Moment | null;
    placeHolder?: string;
    classNames?: string;
    disabledDateFunc?: (currentDate: Moment) => boolean;
    disabledTimeFunc?: () => { 
        disabledHours: () => number[]; 
        disabledMinutes: (hour: number) => number[];
        disabledSeconds?: (hour: number, minute: number) => number[];
    };
    showTime?: boolean | object;
    dateFormat?: string;
    onChangeFunc: (date: Moment | null, dateString: string) => void;
}

const EqDatePicker: React.FC<IDatePickerOptions> = ({
    label,
    isSuffixIcon = false,
    isBordered = true,
    isDisabled = false,
    defaultValue,
    placeHolder = '',
    classNames = '',
    disabledDateFunc,
    showTime = false,
    dateFormat = 'DD/MM/YYYY',
    disabledTimeFunc,
    onChangeFunc,
}) => {
    const handleDateChange = (date: Moment | null, dateString: string) => {
        onChangeFunc(date, dateString);
    };

    const getMomentValue = () => {
        if (!defaultValue) return undefined;
        return moment.isMoment(defaultValue) ? defaultValue : moment(defaultValue);
    };

    return (
        <div className={`eq-date-pick ${classNames}`}>
            {label && <label className="eq-label">{label}</label>}

            <DatePicker
                showTime={showTime}
                disabledTime={disabledTimeFunc}
                placeholder={placeHolder}
                format={dateFormat}
                allowClear={false}
                suffixIcon={isSuffixIcon ? (
                    <span className="calendar-icon">
                        <img alt="Calendar" src="/Calendar-alt.svg" />
                    </span>
                ) : null}
                bordered={isBordered}
                value={getMomentValue()}
                disabled={isDisabled}
                disabledDate={disabledDateFunc}
                onChange={handleDateChange}
            />
        </div>
    );
};

export default EqDatePicker;